import { render, staticRenderFns } from "./services.vue?vue&type=template&id=ba7dd968&scoped=true&lang=html&"
import script from "./services.vue?vue&type=script&lang=js&"
export * from "./services.vue?vue&type=script&lang=js&"
import style0 from "./services.vue?vue&type=style&index=0&id=ba7dd968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7dd968",
  null
  
)

export default component.exports